"use strict";
/**
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@nestjs/common");
const core_1 = require("@nestjs/core");
const app_module_1 = require("./app/app.module");
const environment_ts_1 = require("../../service-lib/src/lib/environment.ts");
const swagger_ts_1 = require("../../service-lib/src/lib/swagger.ts"); //import global swagger setup from service-lib
async function bootstrap() {
    const app = await core_1.NestFactory.create(app_module_1.AppModule);
    const globalPrefix = 'service-registry';
    app.setGlobalPrefix(globalPrefix);
    const port = environment_ts_1.ENV.PORT_SERVICE_REGISTRY || 3002;
    console.log("ENV.PORT_SERVICE_REGISTRY", environment_ts_1.ENV.PORT_SERVICE_REGISTRY);
    console.log("process.env.PORT", port);
    // Set up Swagger documentation for the Service Registry
    (0, swagger_ts_1.setupSwagger)(app, 'Service Registry');
    await app.listen(port);
    common_1.Logger.log(`🚀 Application is running on: http://localhost:${port}/${globalPrefix}`);
}
bootstrap();
